module.exports = __webpack_public_path__ + "img/770.7d22fd1b.jpg";